import { Club } from "../../types/club/Club";
import { TrainingGroup } from "../../types/training-group/TrainingGroup";
import { SportAssociationNumberOf } from "../../types/SportAssociation";

export type SingleClubResponse = {
  club?: Club;
  trainingGroups: TrainingGroup[];
};

export const fetchClub = async (
  backendUrl: string,
  id: string,
  sportAssociation: string,
): Promise<SingleClubResponse> => {
  const response = await fetch(backendUrl + "/club/" + id, {
    headers: {
      "Content-Type": "application/json",
      "X-Sport-Association": SportAssociationNumberOf(sportAssociation),
    },
  });
  const data = await response.json();
  return data;
};
